import { ThemeConfig } from 'antd'

export const baseTheme = ({ token, components, ...otherConfig }: ThemeConfig, appTheme?: string): ThemeConfig => {

  return {
    token: {
      colorPrimary: '#4382E3',
      colorTextBase: '#101828', //$color-gray-dark
      colorTextSecondary: '#475467',
      fontFamily: 'var(--font-be-vietnam-pro), sans-serif',
      ...token
    },
    components: {
      ...components,
      Layout: {
        headerBg: '#ffffff',
        ...components?.Layout
      },
      Modal: {
        ...components?.Modal
      }
    },
    ...otherConfig
  }
}